const getClientConfig = () => {
    const hostname = window.location.hostname; // e.g., "client-001.li.gosoftlab.com"
    const clientId = hostname.split('.')[0];   // Extract "client-001"
    
    return {
      clientId,
      API_BASE_URL: `https://${clientId}.app.gosoftlab.com/api`,

      // API_BASE_URL: `http://172.168.10.105:8080/api`,

    };
  };
  
  export default getClientConfig;